import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  DIVISION_GET_REQUEST,
  DIVISION_GET_SUCCESS,
  DIVISION_GET_FAILURE,
  DIVISION_GET_RESET,
  DIVISION_LIST_REQUEST,
  DIVISION_LIST_SUCCESS,
  DIVISION_LIST_FAILURE,
  DIVISION_LIST_RESET,
  DIVISION_CREATE_REQUEST,
  DIVISION_CREATE_SUCCESS,
  DIVISION_CREATE_FAILURE,
  DIVISION_CREATE_RESET,
  DIVISION_EDIT_REQUEST,
  DIVISION_EDIT_SUCCESS,
  DIVISION_EDIT_FAILURE,
  DIVISION_EDIT_RESET,
  DIVISION_DEACTIVATE_REQUEST,
  DIVISION_DEACTIVATE_SUCCESS,
  DIVISION_DEACTIVATE_FAILURE,
  DIVISION_DEACTIVATE_RESET,
  DIVISION_EXPORT_REQUEST,
  DIVISION_EXPORT_SUCCESS,
  DIVISION_EXPORT_FAILURE,
  DIVISION_EXPORT_RESET,
} from './../../constants'

export function createDivision(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/divisions`,
      method: 'POST',
      types: [
        DIVISION_CREATE_REQUEST,
        DIVISION_CREATE_SUCCESS,
        DIVISION_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getDivision(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/divisions`,
      method: 'GET',
      types: [
        DIVISION_LIST_REQUEST,
        DIVISION_LIST_SUCCESS,
        DIVISION_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getDivisionByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/divisions/${id}`,
      method: 'GET',
      types: [
        DIVISION_GET_REQUEST,
        DIVISION_GET_SUCCESS,
        DIVISION_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editDivision(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/divisions/${id}`,
      method: 'PUT',
      types: [
        DIVISION_EDIT_REQUEST,
        DIVISION_EDIT_SUCCESS,
        DIVISION_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateDivision(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/divisions/${id}/delete`,
      method: 'PUT',
      types: [
        DIVISION_DEACTIVATE_REQUEST,
        DIVISION_DEACTIVATE_SUCCESS,
        DIVISION_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportDivision(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments/exports`,
      method: 'GET',
      types: [
        DIVISION_EXPORT_REQUEST,
        DIVISION_EXPORT_SUCCESS,
        DIVISION_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListDivision() {
  return {
    type: DIVISION_LIST_RESET,
  }
}
export function resetCreateDivision() {
  return {
    type: DIVISION_CREATE_RESET,
  }
}
export function resetEditDivision() {
  return {
    type: DIVISION_EDIT_RESET,
  }
}
export function resetGetDivision() {
  return {
    type: DIVISION_GET_RESET,
  }
}
export function resetDeactivateDivision() {
  return {
    type: DIVISION_DEACTIVATE_RESET,
  }
}
export function resetExportDivision() {
  return {
    type: DIVISION_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/division/division-action.js